import { render, staticRenderFns } from "./InquiryOffersCart.vue?vue&type=template&id=8771073e&"
import script from "./InquiryOffersCart.vue?vue&type=script&lang=js&"
export * from "./InquiryOffersCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports